/* unplugin-vue-components disabled */import script from "./PriceModeConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceModeConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./PriceModeConfirmModal.vue?vue&type=style&index=0&id=7f4a180d&lang=less"
import "./PriceModeConfirmModal.vue?vue&type=style&index=1&id=7f4a180d&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4a180d"]])

export default __exports__